module.exports = __webpack_public_path__ + "img/logo-c.65f529b6.png";